export function bem(args: string[], modifier?: boolean) {
  return args.join(modifier ? '--' : '__');
}
